export default __webpack_public_path__ + "static/media/wrench.4247f1c2.svg";